enum CampaignPlatformType {
  Omnichannel = 'Omnichannel',
  Google = 'Google',
}

export default CampaignPlatformType;
